
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Product } from '@/types/portfolio';

interface ProductDetailsProps {
  product: Product;
}

export const ProductDetails = ({ product }: ProductDetailsProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'certified':
        return 'bg-green-100 text-green-800';
      case 'in_progress':
        return 'bg-blue-100 text-blue-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Product Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h3 className="font-medium text-sm text-muted-foreground mb-1">Product Name</h3>
          <p className="font-medium">{product.name}</p>
        </div>
        
        {product.description && (
          <div>
            <h3 className="font-medium text-sm text-muted-foreground mb-1">Description</h3>
            <p className="text-sm">{product.description}</p>
          </div>
        )}
        
        <div>
          <h3 className="font-medium text-sm text-muted-foreground mb-1">Product Type</h3>
          <p className="text-sm capitalize">{product.product_type}</p>
        </div>
        
        {product.manufacturer && (
          <div>
            <h3 className="font-medium text-sm text-muted-foreground mb-1">Manufacturer</h3>
            <p className="text-sm">{product.manufacturer}</p>
          </div>
        )}
        
        <div>
          <h3 className="font-medium text-sm text-muted-foreground mb-1">Certification Status</h3>
          <Badge className={getStatusColor(product.certification_status)}>
            {product.certification_status.replace('_', ' ').toUpperCase()}
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
};
